import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import { useBatchId } from './useBatchId';
import { LOGIN } from '../shared/Routes';

export const useRedirectToLogin = () => {
	const [redirectToLogin, setRedirectToLogin] = useState<boolean>(false);
	const {
		initiated,
		isLoggedIn,
		loading,
		logout,
		firebaseId,
		mySrcmProfile,
		srcmId,
	} = useAuth();
	const { navigateToRoute } = useBatchId();

	useEffect(() => {
		if (redirectToLogin) {
			navigateToRoute(LOGIN);
			return;
		}

		if (initiated) {
			if (isLoggedIn && isLoggedIn()) {
				setRedirectToLogin(false);
			} else {
				setRedirectToLogin(true);
			}
		}
	}, [isLoggedIn, initiated, redirectToLogin, navigateToRoute]);

	return { loading, logout, firebaseId, srcmId, mySrcmProfile };
};
